
// => Styling
import styles from './StatusIcon.module.css';

// => 3rd party components
import { Tooltip } from 'react-tooltip';


// ============
// Component
// ============
const StatusIcon = ({ 
    tooltip = null,
    id = "none",
    children
}) => {


    // RENDER
    // ---------
    return(
        <div className={styles.container}
            data-tooltip-id={id}
            data-tooltip-place='bottom-start'
            data-tooltip-offset={10}
            data-tooltip-variant='dark'>
            {children}
            {tooltip &&
            <Tooltip id={id}>
                {tooltip}
            </Tooltip>}
        </div>
    )
}


export default StatusIcon